const mq = window.matchMedia("(max-width: 989px)");

const productTitleEl = document.querySelector('.product__title__wrapper .product__title');
const productTitleDesktopContainer = productTitleEl.parentElement;
const productTitleMobileContainer = document.querySelector('.product__mobile-only .product__title__wrapper');

let shopifyAppBlocks, jdgmWidget, jdgmDesktopContainer;
const jdgmMobileContainer = document.querySelector('.product__mobile-only .jdgm-wrapper');

document.addEventListener('DOMContentLoaded', () => {
    shopifyAppBlocks = document.querySelectorAll('.shopify-app-block');

    if (!shopifyAppBlocks) return;

    shopifyAppBlocks.forEach(block => {
        if (block.querySelector('.jdgm-preview-badge')) {
            jdgmWidget = block;
            jdgmDesktopContainer = block.parentElement;
        }
    });

    moveMobileEls();
});

mq.addEventListener('change', moveMobileEls);

function moveMobileEls() {
    if (mq.matches) {
        if (jdgmWidget && jdgmMobileContainer) {
            jdgmMobileContainer.append(jdgmWidget);
            jdgmDesktopContainer.style.display = 'none';
        }
        if (productTitleEl && productTitleMobileContainer) {
            productTitleMobileContainer.append(productTitleEl);
        }
    } else {
        if (jdgmWidget && jdgmDesktopContainer) {
            jdgmDesktopContainer.append(jdgmWidget);
            jdgmDesktopContainer.style.display = 'block';
        }
        if (productTitleEl && productTitleDesktopContainer) {
            productTitleDesktopContainer.append(productTitleEl);
        }
    }
}